import { Moment } from 'moment-timezone';

import { Interval } from '../types';

export function getStartAndEndOfDay(date: Moment): Interval {
  const startOfDay = date.clone().startOf('day');

  return [
    startOfDay.valueOf(),
    startOfDay.clone().add(1, 'day').valueOf(),
  ];
}
